import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import ArticleCard from '@/app/components/article/Card.vue'
import ArticleCTACard from '@/app/components/article/CTACard.vue'
import BookCard from '@/app/components/book/card/BookCard.vue'
import BookCTACard from '@/app/components/book/card/BookCTACard.vue'
import EpisodeCard from '@/app/components/podcast/card/EpisodeCard.vue'
import CollectionCard from '@/app/components/collections/card/CollectionCard.vue'
import PodcastCard from '@/app/components/podcast/card/PodcastCard.vue'
import ContinueReadingCard from '@/app/components/book/card/ContinueReadingCard.vue'
import NewReleasesCard from '@/app/components/book/card/NewReleasesCard.vue'

import { ListView } from '@/models/docs.list'
import { ListItem, ListItemType } from '@/models/interfaces'
import { Component, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCard',
  props: {
    view: null,
    doc: null
  },
  setup(__props: any) {

const props = __props as {
  view: ListView
  doc: ListItem
};



const cardComponents: Record<ListItemType, Component> = {
  book: BookCard,
  article: ArticleCard,
  podcast_episode: EpisodeCard,
  collection: CollectionCard,
  podcast: PodcastCard,
  custom_list: CollectionCard,
}

const ctaComponents = {
  book: BookCTACard,
  article: ArticleCTACard,
  // Episodes do not haveCTAs for now
  // podcast_episode: EpisodeCTACard,
}

const cardComponent = computed(() => {
  switch (props.view.customCardComponent) {
    case 'ContinueReadingCard':
      return ContinueReadingCard
    case 'NewReleasesCard':
      return NewReleasesCard
    default:
      return cardComponents[props.view.docTypeName()]
  }
})

return (_ctx: any,_cache: any) => {
  return (__props.doc.title === 'CTA')
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(ctaComponents[__props.view.docTypeName()]), { key: 0 }))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(cardComponent)), {
        key: 1,
        class: "doc__item",
        view: __props.view.docs(),
        doc: __props.doc,
        customList: __props.view.customList
      }, null, 8, ["view", "doc", "customList"]))
}
}

})